// extracted by mini-css-extract-plugin
export default {"error-display-text":"pages_error-display-text__qqdLz","error-code-text":"pages_error-code-text__hdj-g"};